import { Link } from 'react-router-dom';

interface ClosingCtaProps {
  eyebrow: string;
  lines: string[];
}

export default function ClosingCta({ eyebrow, lines }: ClosingCtaProps) {
  return (
    <section aria-label="Start a project" className="bg-accent-100 py-24 md:py-36">
      <div className="px-4 md:px-6">
        <p className="font-label text-[11px] uppercase tracking-[0.18em] text-foreground-700" data-reveal="up">{eyebrow}</p>
        <Link to="/contact" className="group mt-6 block w-fit cursor-pointer">
          <span className="block font-extrabold uppercase tracking-[-0.06em] leading-[0.86] text-foreground-950 text-[clamp(2.6rem,9vw,9.5rem)] group-hover:text-primary-500 transition-colors" data-reveal="lines">
            {lines.map((l) => (
              <span key={l} className="line-mask"><span className="line-inner">{l}</span></span>
            ))}
          </span>
          <span className="mt-8 inline-flex items-center gap-3 border-b-2 border-foreground-950 pb-1 font-label text-[11px] uppercase tracking-[0.16em] text-foreground-950 group-hover:border-primary-500 group-hover:text-primary-500 transition-colors whitespace-nowrap">
            Start a project
            <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"><i className="ri-arrow-right-line" /></span>
          </span>
        </Link>
      </div>
    </section>
  );
}